<ion-header no-border mode="md">
    <ion-toolbar color="primary" mode="md">
        <ion-title>
            {{ title | translate }}
        </ion-title>
        <ion-buttons slot="end">
            <ion-button color="light" (click)="close()" mode="ios">
                <ion-icon class="bp-close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="content">
    <div class="container-wrapper">
        <ion-col size="12" size-lg="7" removePad>
            <div class="job-table">
                <ion-grid>
                    <ion-row lrm header>
                        <ion-col size="1">Id</ion-col>
                        <ion-col centeredCol size="4">
                            <span>{{'generic.job.description' | translate}}</span>
                        </ion-col>
                        <ion-col centeredCol size="3">
                            <span>  {{'generic.job.status' | translate}}</span>
                        </ion-col>
                        
                        <ion-col centeredCol size="2">
                            <span>{{'generic.job.progress' | translate}}</span>
                        </ion-col>
                        <ion-col centeredCol size="2">
                            <span>{{'generic.job.action' | translate}}</span>
                        </ion-col>
                    </ion-row>
                    <ion-row lrm body *ngFor="let job of jobs | async; let uIndex = index">
                        <ion-col size="1">
                            <b>{{job?.jobId}}</b>
                        </ion-col>
                        <ion-col centeredCol size="4">
                            <span>{{job.jobName | translate}}</span>
                        </ion-col>
                        <ion-col centeredCol size="3">
                            <span>{{job.status }}{{ job.status == 8 ? ('generic.job.failed' | translate) :  job.progress.message | translate}}</span>
                        </ion-col>
                        <ion-col centeredCol size="2">
                            <span>{{ job.progress.progressPercentage > 100 ? 99 : job.progress.progressPercentage }}%</span>
                        </ion-col>
                        <ion-col centeredCol size="2">
                            <ion-button  *ngIf="job.progress.status !== 8" color="primary"
                                        [disabled]="!job.progress.data||job.progress.progressPercentage < 100"
                                        (click)="goToUrl(job.progress.data)">
                                download
                            </ion-button>
                            <div class="failed-status"
                                [matTooltip]="job.progress.message"
                                *ngIf="job.progress.status === 8"
                            >
                                <img src="./assets/imgs/denied.png" />
                                <p>Failed</p>
                            </div>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>
        </ion-col>
    </div>
    <div class="divider"></div>
    <div class="footer">

        <ion-button class="btn-save" color="primary" (click)="close()">
            {{ 'generic.close' | translate }}
        </ion-button>
    </div>
</ion-content>
